import { useQuery } from "@apollo/client"
import { Link, useParams } from "react-router-dom"
import { gql } from "~/__generated__"
import { GraphqlError } from "~/ui/errors"
import { useDocumentTitle } from "~/common/use-document-title"
import { ScreenLoading } from "~/ui/screen-loading"
import { columns } from "./columns"
import { DataTable } from "~/admin/data-table"
import { Button } from "~/ui/button"
import { myLettermemeManagePath } from "~/common/paths"

const newsletterInputsQuery = gql(/* GraphQL */ `
  query NewsletterInputs($lettermemeId: ID!, $first: Int = 50, $after: String) {
    newsletterInputs(lettermemeId: $lettermemeId, first: $first, after: $after) {
      edges {
        node {
          id
          subject
          sender
          originalSender
          state
          createdAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`)

export const NewsletterInputsScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { data, fetchMore, error, loading } = useQuery(newsletterInputsQuery, {
    variables: { lettermemeId: id! },
    skip: !id,
  })

  useDocumentTitle("Newsletter Inputs")

  if (error) return <GraphqlError error={error} />
  if (loading) return <ScreenLoading />

  const newsletterInputs = data?.newsletterInputs.edges.map((edge) => edge.node) ?? []
  const pageInfo = data?.newsletterInputs.pageInfo

  return (
    <div className="mx-auto max-w-7xl p-8">
      <div className="mb-8">
        <Link to={myLettermemeManagePath({ id: id! })} className="text-gray-400">
          ← back to lettermeme settings
        </Link>
        <h1 className="mt-4 text-2xl font-bold">Newsletter Inputs</h1>
        <p className="text-gray-400">Emails received for this lettermeme</p>
      </div>
      <DataTable columns={columns} data={newsletterInputs} />
      {pageInfo && pageInfo.hasNextPage && (
        <div className="mt-4">
          <Button
            variant="outline"
            onClick={() => {
              fetchMore({
                variables: {
                  after: pageInfo.endCursor,
                },
              })
            }}
          >
            Load more
          </Button>
        </div>
      )}
    </div>
  )
}
